<template>
    <div class='altrama-extension'>
        <loading
            loader="dots"
            :active.sync="isLoading" 
            :opacity="0.8"
            :height="200"
            :width="200"
            color="#5c7990"
            :can-cancel="false" 
            :is-full-page="true">
        </loading>

        <div class="wrap">
            <h1 class="wp-heading-inline title">Pannello di gestione dei metadati dei dataset degli OpenData</h1>
            <div class="d-flex flex-wrap mt-5">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="bootstrap-select-wrapper">
                        <label for="select-dataset">Dataset</label>
                        <select id="select-dataset"
                            title="Nessuna Selezione"
                            v-model="dataset"
                            data-live-search="true" 
                            data-live-search-placeholder="Nessuna Selezione"
                        >
                            <option v-for="dataset in datasets" v-bind:key="dataset">
                                {{ dataset }} 
                            </option>
                        </select>
                    </div>
                    <input type="submit" id="search-submit" class="button my-3" value="Carica dataset" v-on:click="loaddataset()">
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12" v-if="currentDataset.title">
                    <div class="mb-3"><strong>Id del dataset </strong>{{currentDataset.id}}</div>
                    <div class="mb-3"><strong>Nome del dataset </strong>{{currentDataset.title}}</div>
                    <div class="mb-3"><strong>Descrizione del dataset </strong>{{currentDataset.description}}</div>
                    <div class="mb-3"><strong>Organizzaione </strong>{{currentDataset.organization}}</div>
                    <div v-if="currentDataset.resources.length>0" >                    
                        <div class="bootstrap-select-wrapper">
                            <label for="select-dataset">Risorse</label>
                            <select id="select-dataset"
                                title="Nessuna Selezione"
                                v-model="resource"
                                data-live-search="true" 
                                data-live-search-placeholder="Nessuna Selezione"
                            >
                                <option v-for="resource in currentDataset.resources" v-bind:key="resource.id" :value="resource.id">
                                    {{ resource.name }} 
                                </option>
                            </select>
                        </div>
                        <input type="submit" id="search-submit" class="button my-3" value="Carica risorsa" v-on:click="loadresources()">                    
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column mt-5" v-if="currentResource">
                <h5><strong>{{currentResource.description}}</strong></h5>
                <div class="meta-table" v-if="Object.keys(filteredItems).length>0"> 
                        <div class="d-flex flex-wrap m-0 table-int h6"> 
                            <div class="col-lg-5 col-md-5 py-3 col-sm-12"><strong>Campo</strong></div>
                            <div class="col-lg-5 col-md-5 py-3 col-sm-12"><strong>Valore</strong></div>
                            <div class="col-lg-2 col-md-2 col-12"></div>
                        </div>
                        <div class="d-flex flex-wrap table-row" v-for="(value, name) in filteredItems" v-bind:key="(value,name)">
                            <div class="col-lg-5 col-md-5 col-sm-12 d-flex py-2 align-items-center">{{filterout(name)}}</div>
                            <div class="col-lg-5 col-md-5 col-sm-12 d-flex py-2 align-items-center">{{value}}</div>
                            <div class="col-lg-2 col-md-2 col-sm-12 d-flex">
                                <input type="submit" class="button mx-auto my-1" value="Elimina" v-on:click="deletemeta(name)">                    
                            </div>
                        </div>
                </div>
                <div class="my-4 h5" v-else>
                    Non ci sono metadati
                </div>
                <div class="d-flex flex-wrap my-3 add-section">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <label for="metaname">Nome del metadato</label>
                        <input id="metaname" type="text" placeholder="Nome del metadato" v-model="metaname">
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <label for="metavalue">Valore del metadato</label>
                        <input id="metavalue" type="text" placeholder="Valore del metadato" v-model="metavalue">
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <input type="submit" class="button mx-auto my-1" value="Aggiungi metadato" v-on:click="add()">  
                    </div>
                </div>
                <div class="d-flex my-3">
                    <input type="submit" class="button mx-auto my-1" value="Salva" v-on:click="save()">                    
                </div>                
            </div>
        </div>

    </div>
</template>

<script>
import axios from "axios";
var $ = window.jQuery;
export default {
    components: {},
    computed: {
        isLoading:function(){
            return (this.loadingResource);
        },
        filteredItems:function(){
            const defaultfield= ['cache_last_updated','cache_url','created','datastore_active','description','format',
                                'hash','id','last_modified','metadata_modified','mimetype','mimetype_inner','name',
                                'package_id','position','resource_type','size','state','url','url_type'];
            const filtered = Object.keys(this.currentResource)
            .filter(key => !defaultfield.includes(key))
            .reduce((obj, key) => {
                obj[key] = this.currentResource[key];
                return obj;
            }, {});
            return filtered;
        },        
    },

    props: ["default_attribute"],

    created() {
        this.loadResource();
    },

    updated() {
        $("select").selectpicker(); //per la multiselect
        this.$jQueryWrapSelect(); //singole select
        $('select').selectpicker('refresh');        
    },

    data() {
        return {
            apikey:"1e236466-bda1-403f-b3a2-94eb39e71a9c",

            loadingResource: false,

            dataset:-1,
            datasets:[],

            currentDataset:{id:"",title:"",description:"",organization:"",resources:[]},
            
            resource:-1,

            currentResource:null,
            
            metaname:"",
            matavalue:"",
        };
    },
    methods: {
        loadResource(){
            var self= this;
            self.loadingResource=true;
            axios.get(this.default_attribute.concat("package_list"),{
                headers:{
                    'Authorization': self.apikey
                }
            })
            .then(function(response){
                response.data.result.forEach((element) => self.datasets.push(element));
                self.resource=-1;
                self.currentDataset={id:"",title:"",description:"",organization:"",resources:[]};  
                self.currentResource=null; 
                self.loadingResource=false;
            })
            .catch(function(error){});
        },
        loaddataset(){
            var self= this;
            self.loadingResource=true;
            axios.get(this.default_attribute.concat('package_search?fq=name:"').concat(self.dataset).concat('"'),{
                headers:{
                    'Authorization': self.apikey
                }
            })
            .then(function(response){
                if (response.data.result.count>=1){
                    self.resource=-1;
                    self.currentDataset={id:"",title:"",description:"",organization:"",resources:[]};   
                    self.currentResource=null; 
                    response.data.result.results[0].resources.forEach((element) => self.currentDataset.resources.push(element));
                    self.currentDataset.id=response.data.result.results[0].id;
                    self.currentDataset.title=response.data.result.results[0].title;
                    self.currentDataset.description=response.data.result.results[0].notes;
                    self.currentDataset.organization=response.data.result.results[0].organization.title;
                }
                self.loadingResource=false;
            })
            .catch(function(error){});            
        },
        loadresources(){
            var self= this;
            self.loadingResource=true;
            axios.get(this.default_attribute.concat('resource_show?id=').concat(self.resource),{
                headers:{
                    'Authorization': self.apikey
                }
            })
            .then(function(response){
                self.currentResource=response.data.result;
                self.loadingResource=false;
            })
            .catch(function(error){});  
        },

        deletemeta(name){
            this.$delete(this.currentResource,name);
            
        },
        add(){
            this.$set(this.currentResource,this.filterin(this.metaname),this.metavalue);
            this.metaname="";
            this.metavalue="";
        },
        filterout(text){
            return text.replace('_',' ');
        },
        filterin(text){
            return text.replace(' ','_');
        },        
        save(){
            var self= this;
            self.loadingResource=true;

            axios.post(this.default_attribute.concat('resource_update'),self.currentResource, {
                headers: {
                    'Authorization': self.apikey
                }
            })
            .then(function(response){
                alert('Salvataggio effettuato con successo');
                self.loadingResource=false;
            })
            .catch(function(error){
                alert('Salvataggio fallito. Riprovare');
                self.loadingResource=false;                
            });  
            
        }
    },
}
</script>